import { styled } from 'styled-components';
import Photo from '../../assets/images/04@2x.png';
export const Container = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  padding: 30px 30px 30px 200px;
  gap: 190px;

  @media (max-width: 1900px) {
    padding: 30px;
  }
  @media (max-width: 1090px) {
    background-image: url(${Photo});
    background-size: cover;
    background-repeat: no-repeat;
    padding: 0;
  }
`;
export const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  padding: 50px;
  gap: 190px;
  @media (max-width: 1600px) {
    gap: 50px;
  }
  @media (max-width: 1385px) {
    flex-direction: column;
    gap: 120px;
  }
`;

export const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 1400px) {
    position: absolute;
    background-color: white;
    padding: 30px;
    border-radius: 20px;
    box-shadow: 24px 24px 24px 12px rgba(0, 0, 0, 0.1);
  }
  @media (max-width: 485px) {
    width: 100%;
    border-radius: 0px;
  }
`;
export const GoogleMapLeftContainer = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 485px) {
    width: 100%;
    border-radius: 0px;
  }
`;

export const GoogleMapContainer = styled.div`
  max-height: 92dvh;
  min-height: 400px;
  height: 800px;
  width: 809px;
  display: flex;
  justify-content: center;
  border-radius: 40px;
  box-shadow: 24px 24px 24px 12px rgba(0, 0, 0, 0.1);
  @media (max-width: 1600px) {
    height: 600px;
  }
  @media (max-width: 1385px) {
    margin-top: -140px;
    width: 100%;
  }
  @media (max-width: 600px) {
    height: 500px;
  }
`;

export const Image = styled.img`
  max-height: 92dvh;
  border-radius: 40px;
  min-height: 400px;
  height: 92dvh;
  width: 809px;

  box-shadow: 24px 24px 24px 12px rgba(0, 0, 0, 0.1);
  object-fit: cover;
  background-repeat: no-repeat;
  background-position: center;
  @media (max-width: 1500px) {
    width: 50%;
  }
  @media (max-width: 1090px) {
    display: none;
  }
`;
